import Modal from '@components/Modal';
import { yupResolver } from '@hookform/resolvers/yup';
import React, { useEffect, useState } from 'react';
import Nav from 'react-bootstrap/lib/Nav';
import NavItem from 'react-bootstrap/lib/NavItem';
import { useForm } from 'react-hook-form';
import { Translate } from 'react-redux-i18n';
import * as yup from 'yup';
import { nameRule, passwordRule, confirmPasswordRule } from './validation';

const infoSchema = yup.object().shape({
  name: nameRule,
});

const passwordSchema = yup.object().shape({
  password: passwordRule,
  confirmPassword: confirmPasswordRule,
});

const EditChild = ({
  show,
  close,
  child,
  onChangeInfo,
  onChangePassword,
  onDelete,
}) => {
  const [viewMode, setViewMode] = useState(1);
  const isDataChangeMode = viewMode === 1;

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    mode: 'all',
    defaultValues: child,
    resolver: yupResolver(isDataChangeMode ? infoSchema : passwordSchema),
  });

  const onSubmit = data => {
    isDataChangeMode ? onChangeInfo(data) : onChangePassword(data);
  };

  useEffect(() => {
    reset(child);
  }, [child, reset]);

  return (
    <Modal
      show={show}
      close={close}
      hideClose={true}
      dialogClassName="with-robot-head"
      id="modal-editProfile"
    >
      <div className="row modal-robot-body text-center ">
        <div className="robot-head">
          <img
            src={require('../../../assets/images/robot-green-happy-head.svg')}
            alt="progkids-green-robot"
          />
        </div>
        <br />

        <form
          onSubmit={handleSubmit(onSubmit)}
          className="col-xs-12 form-group"
        >
          <Nav
            bsStyle="tabs"
            justified
            activeKey={viewMode}
            onSelect={key => setViewMode(key)}
          >
            <NavItem eventKey={1}>Информация</NavItem>
            <NavItem eventKey={2}>Безопасность</NavItem>
          </Nav>
          {viewMode === 1 && (
            <>
              <div className={`form-group`}>
                <span>Игровой ник:</span>
                <input
                  type="text"
                  className="form-control"
                  {...register('name')}
                  autoComplete="username"
                />
                <span className="help-block-error">
                  {(errors['name'] || {}).message}
                </span>
              </div>

              <div className={`form-group`}>
                <span>Имя:</span>
                <input
                  type="text"
                  className="form-control"
                  {...register('realname')}
                  autoComplete="username"
                />
              </div>

              <div className={`form-group`}>
                <span>Возраст:</span>
                <input
                  type="text"
                  className="form-control"
                  {...register('age')}
                />
              </div>
            </>
          )}
          {viewMode === 2 && (
            <>
              <div className={`form-group has-success`}>
                <span>Новый пароль:</span>
                <input
                  type="password"
                  className="form-control"
                  {...register('password')}
                />
              </div>

              <div className={`form-group has-success`}>
                <span>Повторите новый пароль:</span>
                <input
                  type="password"
                  className="form-control"
                  {...register('confirmPassword')}
                />
                <span className="help-block">
                  {errors.confirmPassword && errors.confirmPassword.message}
                </span>
              </div>
            </>
          )}
          <button
            type="button"
            className="btn btn-red text-uppercase"
            onClick={onDelete}
          >
            <Translate value="settings.personal.game.delete" />
          </button>{' '}
          <button className="btn btn-green-small text-uppercase">
            <Translate value="settings.personal.game.change" />
          </button>
        </form>
      </div>
    </Modal>
  );
};

export default EditChild;
